import { useRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../../Context/LanguageContext';

import TotalModalWrapper from '../../../Share/Normal/TotalModalWrapper';
import LogoPath from '../../../../image/CompleteSignUpLogo.png';

export default function SaveCompleteModal(props) {
  const { closeFn } = props;
  const { t } = useLanguage();

  const TopLevelRef = useRef();

  return (
    <TotalModalWrapper>
      <TopLevelWrapper ref={TopLevelRef}>
        <LogoWrapper>
          <Logo src={LogoPath} />
        </LogoWrapper>
        <ExplanationWrapper>
          <ExplanationText>{t('system.saveComplete')}</ExplanationText>
        </ExplanationWrapper>
        <GoBackButton onClick={closeFn}>
          <ButtonText>{t('system.goBack')}</ButtonText>
        </GoBackButton>
      </TopLevelWrapper>
    </TotalModalWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 454px;
  height: 268px;

  border-radius: 50px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.5s ease-in-out;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: -140px;
`;

const Logo = styled.img`
  width: 200px;
  height: 200px;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: center;
  align-items: center;

  width: 90%;
`;

const ExplanationText = styled.pre`
  font-family: NotoSansKR-Bold;
  font-size: 25px;

  margin: 0 0 0 0;

  color: ${props => props.theme.text};
`;

const GoBackButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 282px;
  height: 36px;

  background-color: ${props => props.theme.primary};
  border-radius: 23px;

  margin-top: 47px;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background: ${props => props.theme.primaryHover};
    }
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: ${props => props.theme.subBackground};

  margin: 0 0 0 0;
`;
